import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import ReactCalendar from '../../../components/react-calendar';
import Spinner from '../../../components/ui/spinner';
import { useAppSelector } from '../../../store';
import { getOnCalendarEvents, setPage } from '../../../store/features/moments/momentsSlice';
import ButtonDot from '../home-feed/buttonDot';

const SectionCalendar = () => {
    const [date1Start, setDate1Start] = useState<Date>(new Date());
    const [date2Start, setDate2Start] = useState<Date>(new Date());
    const [date3Start, setDate3Start] = useState<Date>(new Date());

    const [date1Value, setDate1Value] = useState<Date>(new Date());
    const [date2Value, setDate2Value] = useState<Date>(null);
    const [date3Value, setDate3Value] = useState<Date>(null);

    const { words } = useAppSelector(state => state.localization);
    const { calendarEvents, tuttorialIndex, tutorial } = useAppSelector(state => state.moments);
    const dispatch = useDispatch();

    useEffect(() => {
        const newDate_ = new Date(date1Start);
        const currentMonth = newDate_.getMonth() + 1;
        const currentYear = newDate_.getFullYear();
        let _nextMonth = currentMonth === 12 ? 1 : (currentMonth + 1);
        const _date2CurrentYear = currentMonth === 12 ? (currentYear + 1) : currentYear;
        setDate2Start(new Date(_date2CurrentYear + '-' + _nextMonth + '-01'));

        _nextMonth = _nextMonth === 12 ? 1 : (_nextMonth + 1);
        const _date3CurrentYear = currentMonth >= 11 ? (currentYear + 1) : currentYear
        const date3Start_ = new Date(_date3CurrentYear + '-' + _nextMonth + '-01');
        setDate3Start(date3Start_);

        _nextMonth = _nextMonth === 12 ? 1 : (_nextMonth + 1)
        const _currentYear = currentMonth >= 11 ? (currentYear + 1) : currentYear
        const endDate_ = new Date(_currentYear + '-' + _nextMonth + '-01')
        dispatch(getOnCalendarEvents({ startDate: date1Start, endDate: endDate_ }));
    }, []);

    const handleMonthChange = async (e, id) => {
        const newDate = new Date(e.activeStartDate);
        const lastYear = new Date();
        lastYear.setFullYear(lastYear.getFullYear() - 1);
        lastYear.setMonth(lastYear.getMonth() - 1);

        const nextYear = new Date();
        nextYear.setFullYear(nextYear.getFullYear() + 1);
        nextYear.setMonth(nextYear.getMonth() - 3);
        if (newDate < nextYear && newDate > lastYear) {
            if (id === 'calender-01') {
                setDate1Start(e.activeStartDate);
                setDate2Start(new Date(newDate.setMonth(newDate.getMonth() + 1)));
                setDate3Start(new Date(newDate.setMonth(newDate.getMonth() + 1)));
                dispatch(getOnCalendarEvents({ startDate: e.activeStartDate, endDate: newDate }));
            } else if (id === 'calender-02') {
                setDate2Start(e.activeStartDate);
                setDate1Start(new Date(newDate.setMonth(newDate.getMonth() - 1)));
                setDate3Start(new Date(newDate.setMonth(newDate.getMonth() + 2)));
                const newDate_ = new Date(e.activeStartDate);
                dispatch(
                    getOnCalendarEvents({
                        startDate: new Date(newDate_.setMonth(newDate_.getMonth() - 1)),
                        endDate: new Date(newDate_.setMonth(newDate_.getMonth() + 2)),
                    }),
                );
            } else if (id === 'calender-03') {
                setDate1Start(new Date(newDate.setMonth(newDate.getMonth() - 2)));
                setDate2Start(new Date(newDate.setMonth(newDate.getMonth() + 1)));
                setDate3Start(e.activeStartDate);
                const newDate_ = new Date(e.activeStartDate);
                dispatch(getOnCalendarEvents({ startDate: new Date(newDate_.setMonth(newDate_.getMonth() - 2)), endDate: e.activeStartDate }));
            }
        }
    };

    const handleChangeValue = async (e, id) => {
        if (id === 'calender-01') {
            setDate1Value(e);
            setDate1Start(e);
            setDate2Value(null);
            setDate3Value(null);
        } else if (id === 'calender-02') {
            setDate1Value(null);
            setDate2Value(e);
            setDate2Start(e);
            setDate3Value(null);
        } else if (id === 'calender-03') {
            setDate1Value(null);
            setDate2Value(null);
            setDate3Value(e);
            setDate3Start(e);
        }
    };

    return (
        <>
            {tuttorialIndex === 4 && (
                <>
                    <div className={tuttorialIndex > 0 ? 'overlay-01 active' : 'overlay-01'}> </div>
                    <div className="calendar-tutorial">
                        <ButtonDot description={tutorial?.items[3]?.description}></ButtonDot>
                    </div>
                </>
            )}

            {tuttorialIndex === 5 && (
                <>
                    <div className={tuttorialIndex > 0 ? 'overlay-01 active' : 'overlay-01'}> </div>
                    <div className="special-moment-tutorial">
                        <ButtonDot description={tutorial?.items[4]?.description}></ButtonDot>
                    </div>
                </>
            )}

            <div className={tuttorialIndex === 4 ? 'c-container-03 active' : 'c-container-03'} id="calender-container">
                <a href="#!" onClick={() => (tuttorialIndex > 0 ? null : dispatch(setPage({ name: 'createMoment', type: '', id: '' })))}>
                    <div className={tuttorialIndex === 5 ? 'c-item-01 active' : 'c-item-01'}>
                        <svg className="c-item-01-A" width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="34" height="34" rx="8" fill="#00A3FF" />
                            <path
                                d="M24 8H10C8.89543 8 8 8.89543 8 10V24C8 25.1046 8.89543 26 10 26H24C25.1046 26 26 25.1046 26 24V10C26 8.89543 25.1046 8 24 8Z"
                                stroke="white"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path d="M17 13V21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M13 17H21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>

                        <h4 className="c-item-01-B">{words && words['WEB.createMomentPlural']}</h4>

                        <div className="c-item-01-C">
                            <svg className="calendar-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 18L15 12L9 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                    </div>
                </a>

                <div className="c-dot-information">
                    <div className="c-dot-information-01">
                        <div className="c-dot-information-01-A"></div>
                        <span className="c-dot-information-01-B">{words && words['WEB.specialMomentPerson']}</span>
                    </div>
                    <div className="c-dot-information-02">
                        <div className="c-dot-information-02-A"></div>
                        <span className="c-dot-information-02-B">{words && words['WEB.specialMomentOther']}</span>
                    </div>
                </div>

                <div className="c-item-02 moments-page-calender">
                    {calendarEvents.loading && <Spinner />}
                    {!calendarEvents.loading && (
                        <>
                            <ReactCalendar
                                nextLabel={''}
                                prevLabel={''}
                                startDate={date1Start}
                                value={date1Value}
                                handleChangeValue={handleChangeValue}
                                handleMonthChange={handleMonthChange}
                                events={calendarEvents.items}
                                id="calender-01"
                            />
                            <ReactCalendar
                                nextLabel={null}
                                prevLabel={null}
                                startDate={date2Start}
                                value={date2Value}
                                handleChangeValue={handleChangeValue}
                                handleMonthChange={handleMonthChange}
                                events={calendarEvents.items}
                                id="calender-02"
                            />
                            <ReactCalendar
                                nextLabel={null}
                                prevLabel={null}
                                startDate={date3Start}
                                value={date3Value}
                                handleChangeValue={handleChangeValue}
                                handleMonthChange={handleMonthChange}
                                events={calendarEvents.items}
                                id="calender-03"
                            />
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default SectionCalendar;
